import $ from "jquery";

const text_slider = function () {

  $('.js-text-slider').each(function (index) {
    var that = $(this);
    var indexClass = 'slider-' + index;

    that.addClass(indexClass);
    that.slick({
      mobileFirst: true,
      lazyLoad: 'ondemand',
      'dots': true,
      'arrows': false,
      'infinite': true,
      'slidesToShow': 1,
      nextArrow: '<button type="button" class="slick__next fas fa-chevron-right"></button>',
      prevArrow: '<button type="button" class="slick__prev fas fa-chevron-left"></button>',
      'responsive': [
        {
          breakpoint: 768,
          settings: {
            'arrows': true,
            'dots': false,
            'appendArrows': '.' + indexClass + ' .slick-list',
          },
        },
      ],
    });
  })


  //refresh on tab change
  $('a[data-toggle="tab"]').on('shown.bs.tab', function (e) {
    $($(e.target).attr('href')).find('.js-text-slider').slick('refresh');
  })

};

export default text_slider;
